import moment from 'moment'

const moveDateRangeToCustom = dateRange => {
  switch (dateRange) {
    case 'Today': {
      return {
        startDate: moment().add(-1, 'days'),
        endDate: moment()
      }
    }

    case 'Yesterday':  {
      return {
        startDate: moment().add(-2, 'days'),
        endDate: moment().add(-1, 'days')
      }
    }

    case 'This month': {
      return {
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month')
      }
    }

    case 'This week': {
      return {
        startDate: moment().startOf('isoWeek'),
        endDate: moment().endOf('isoWeek')
      }
    }

    case 'Last month': {
      return {
        startDate: moment().subtract(1, 'months').startOf('month'),
        endDate: moment().subtract(1, 'months').endOf('month')
      }
    }

    case 'Last week': {
      return {
        startDate: moment().subtract(1, 'weeks').startOf('isoWeek'),
        endDate: moment().subtract(1, 'weeks').endOf('isoWeek')
      }
    }

    case 'Last 30 days': {
      return {
        startDate: moment().add(-30, 'days'),
        endDate: moment()
      }
    }

    case 'Last 7 days': {
      return {
        startDate: moment().add(-7, 'days'),
        endDate: moment()
      }
    }
  }
}

export default moveDateRangeToCustom
